import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function locations() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            page: 1,
            limit: 25,
            pattern: '',
            active: true
        };

        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`location/search${params}`);
    }

    function get(id) {
        console.log('Fetching location with id:', id);
        return axiosInstance.get(`location/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('location/create', data);
    }

    function update(data) {
        return axiosInstance.patch('location/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`location/delete`, {
            data: {
                id: id
            }
        });
    }
}
